"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _sizes = require("HubStyleTokens/sizes");

var _PopoverContext = require("../context/PopoverContext");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n            border-bottom-left-radius: inherit;\n            border-bottom-right-radius: inherit;\n          "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background: inherit;\n  &&& {\n    padding: ", ";\n    ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Body = _styledComponents.default.div.withConfig({
  displayName: "UIPopoverBody__Body",
  componentId: "sc-1lb0dek-0"
})(_templateObject(), function (_ref) {
  var popoverUse = _ref.popoverUse;
  return popoverUse === 'shepherd' ? _sizes.SHEPHERD_PADDING_Y + " " + _sizes.POPOVER_PADDING_X : null;
}, function (_ref2) {
  var popoverUse = _ref2.popoverUse;
  return popoverUse === 'shepherd' ? (0, _styledComponents.css)(_templateObject2()) : null;
});

function UIPopoverBody(_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      flush = _ref3.flush,
      popoverContext = _ref3.popoverContext,
      rest = (0, _objectWithoutProperties2.default)(_ref3, ["children", "className", "flush", "popoverContext"]);
  return _react.default.createElement(Body, (0, _extends2.default)({}, rest, {
    className: (0, _classNames.default)('uiPopoverBody', 'private-popover__body', {
      'private-popover__body--flush': flush
    }, className),
    popoverUse: popoverContext.use
  }), children);
}

UIPopoverBody.propTypes = {
  children: _react.PropTypes.node,
  flush: _react.PropTypes.bool,
  popoverContext: _PopoverContext.popoverContextPropType
};
UIPopoverBody.displayName = 'UIPopoverBody';

var _default = (0, _PopoverContext.ConsumesPopoverContext)(UIPopoverBody);

exports.default = _default;
module.exports = exports.default;